export default __webpack_public_path__ + "static/media/argument.92122a8d.jpg";